import React, { useEffect } from 'react';
import { ChatMessageData } from '../types';
import debounce from 'lodash/debounce';

export const useAutoScroll = (
  chatMessages: ChatMessageData[],
  scrollingDivRef: React.MutableRefObject<null>,
) => {
  const [isScrolledDown, setIsScrolledDown] = React.useState(true);

  const scrollToBottom = () => {
    if (scrollingDivRef.current) {
      const scrollingElement = scrollingDivRef.current as HTMLElement;
      scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }
  };

  // initial on new message
  useEffect(() => {
    scrollToBottom();

    // TODO: this and whole logic needs refactoring
    setTimeout(() => {
      scrollToBottom();
    }, 600);
  }, [chatMessages]);

  // on scroll for arrow down button
  useEffect(() => {
    if (scrollingDivRef.current) {
      const scrollingElement = scrollingDivRef.current as HTMLElement;
      const onScroll = debounce(() => {
        setIsScrolledDown(
          scrollingElement.scrollHeight - scrollingElement.scrollTop - 70 <=
            scrollingElement.clientHeight,
        );
      }, 150);

      scrollingElement.addEventListener('scroll', onScroll);

      return () => {
        scrollingElement.removeEventListener('scroll', onScroll);
      };
    }

    return () => {};
  }, []);

  // scroll down on new line, when user is at the bottom (allow free scroll)
  const autoScroll = () => {
    if (scrollingDivRef.current) {
      const scrollingElement = scrollingDivRef.current as HTMLElement;
      const isScrolledToBottom =
        scrollingElement.scrollHeight - scrollingElement.scrollTop - 70 <=
        scrollingElement.clientHeight;

      if (isScrolledToBottom) {
        scrollToBottom();
      }
    }
  };

  return { isScrolledDown, scrollToBottom, autoScroll };
};
